import { EmbeddedPreviewFundingMethod } from "../components/EmbeddedPreviewFundingMethod";

export const RoutePreviewFundingMethod = () => {
  return <EmbeddedPreviewFundingMethod />;
};
